import {
    FETCH_CPTS_REQUEST, FETCH_CPTS_SUCCESS, FETCH_CPTS_FAILURE,
    CREATE_CPT_SUCCESS, UPDATE_CPT_SUCCESS, DELETE_CPT_SUCCESS,
    FETCH_CPT_RULES_SUCCESS
  } from '../actions/cptActions ';
  
  const initialState = {
    cpts: [],
    rules: [],
    loading: false,
    error: null,
  };
  
  export default function cptReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_CPTS_REQUEST:
        return { ...state, loading: true };
      case FETCH_CPTS_SUCCESS:
        return { ...state, loading: false, cpts: action.payload };
      case FETCH_CPTS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_CPT_SUCCESS:
        return { ...state, cpts: [...state.cpts, action.payload] };
      case UPDATE_CPT_SUCCESS:
        return {
          ...state,
          cpts: state.cpts.map((cpt) => (cpt.id === action.payload.id ? action.payload : cpt)),
        };
      case DELETE_CPT_SUCCESS:
        return { ...state, cpts: state.cpts.filter((cpt) => cpt.id !== action.payload) };
      case FETCH_CPT_RULES_SUCCESS:
        return { ...state, rules: action.payload };
      default:
        return state;
    }
  }
  